import { useMutation } from "@tanstack/react-query";

import { fetchFileInfo } from "#shared/helpers/fetchFileInfo";

export const useFileInformations = (url: string) => {
  const fileInfoMutation = useMutation({
    mutationFn: () => fetchFileInfo(url),
  });

  return {
    fileInfo: fileInfoMutation.data,
    isLoading: fileInfoMutation.isPending,
    fetchFileInfo: fileInfoMutation.mutate,
    error: fileInfoMutation.error,
  };
};
